import generateSafeframeAdImpl from './safeframe/generateSafeframeAd';
import { track } from '../tracking';
import { withAdResponseReceivedEvent } from '../tracking/events';

export default (
    generateSafeframeAd = generateSafeframeAdImpl,
    shouldTrackEvent,
  ) =>
  (adSpot, response) => {
    const {
      contentType,
      content: { fcid, adId, adtype: adType, size },
    } = response;
    adSpot.nativeType = 'html';
    adSpot.prebidAdId = adId;
    adSpot.prebidSize = size;

    const eventProperties = {
      adResponseContentType: contentType,
      fcid,
      jsonResponseAdType: adType,
    };

    track(
      withAdResponseReceivedEvent(eventProperties),
      adSpot,
      shouldTrackEvent,
    );

    return generateSafeframeAd(adSpot);
  };
